import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, MenuItem, MuiThemeProvider,
Grid, Divider, Dialog, Slide, DialogTitle, DialogContent, DialogContentText, Hidden } from '@material-ui/core';
import { } from '@material-ui/icons';
import  AddIcon  from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete'
import CircularProgress from '@material-ui/core/CircularProgress';
import creds from '../config/firebaseConfig';
import db from '../config/firestoreConfig';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        position: 'relative',
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
        },
    paper: {
        padding: theme.spacing.unit * 2,
        position: 'relative',
        paddingBottom: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        height: 'auto',
        overflowX: 'auto',
        width: '75%'
        },
    button: {
        margin: theme.spacing.unit,
        padding: 20,
        width: 150,
        height: 75
        },
    progress: {
        margin: theme.spacing.unit * 2,
        },
})
class manageAbilities extends Component{
    constructor(props){
        super(props)
        this.state = {
            yearName: [],
            contentArr: [],
            open: false,
            openDelete: false,
            loading: true,
        }
    }

    async componentDidMount(){
        const obj = await this.fetchData()
        this.setState({
            yearName: obj.nameArr,
            contentArr: obj.contentArr
        })
    }

    async fetchData() { 
        const ref = db.collection('Level').doc('GCSE').collection('Subjects').doc('English Language').collection('Years').doc('10').collection('Abilities')
        console.log(this.props.match.params.level, this.props.match.params.subject, this.props.match.params.year)
        const nameArr = [];
        const contentArr = [];
        try {
            const snapshot = await ref.get()
            snapshot.docs.forEach(ability => { 
                console.log(ability.id)
                nameArr.push(ability.id)
                contentArr.push(ability.data)
            })
            const obj = {
                'nameArr': nameArr,
                'contentArr': contentArr
            }
            return obj
        } catch (e) { 
            console.log('there was an error')
        }
    }


    render(){
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <Typography variant='headline'>
                        View abilities for 
                    </Typography>
                    <Button onClick={() => {window.location.replace('/' + this.props.match.params.id + '/' + this.props.match.params.acctype + '/' + 'managelevels/' + this.props.match.params.level)}}> 
                        {this.props.match.params.level} 
                    </Button>
                     - 
                    <Button onClick={() => {window.location.replace('/' + this.props.match.params.id + '/' + this.props.match.params.acctype + '/' + 'managelevels/' + this.props.match.params.level + '/' + this.props.match.params.subject)}}> 
                        {this.props.match.params.subject} 
                    </Button>
                     - 
                    <Button color='secondary' onClick={() => {window.location.replace('/' + this.props.match.params.id + '/' + this.props.match.params.acctype + '/' + 'managelevels/' + this.props.match.params.level + '/' + this.props.match.params.subject + '/' + this.props.match.params.year)}}> 
                        { 'Year ' + this.props.match.params.year} 
                    </Button>
                    <Divider/>
                    {this.state.contentArr.length > 0 ? (
                        <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='center'
                        >
                            {this.state.yearName.map(year => {
                                return (
                                    <Grid item xs={3}>
                                        <Button variant='outlined' className={classes.button} onClick={() => window.location.replace(this.props.match.url + '/' + year)}  value={year}>
                                            {year}
                                        </Button>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    ) : (
                        <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='center'
                        >
                            <br/>
                            {this.state.loading ? 
                                <Grid item xs={12}>
                                        <div style={{width: '100%', alignItems: 'center'}}>
                                            <CircularProgress className={classes.progress} color="inherit" />
                                        </div> 
                                        {setTimeout(() => {this.setState({loading: false})}, 2000)}
                                </Grid>  
                            :
                                <Grid item xs={12}>
                                    <Typography variant='subheading' style={{marginTop: 20}}>
                                        You have no ability groups for this subject
                                    </Typography>
                                </Grid> 
                            }
                        </Grid>
                    )}
                </Paper>
            </div>
        )
    }
}
export default withStyles(styles)(manageAbilities);


// WEBPACK FOOTER //
// ./src/admin/manageAbilities.jsx